
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SectionHeader extends Vue {
  @Prop({ required: true }) readonly title!: string;
  @Prop({ default: '' }) readonly subtitle!: string;
  @Prop({ default: '' }) readonly icon!: string;
  @Prop({ default: '#40b99d' }) readonly color!: string;
  @Prop({ default: false }) readonly required!: boolean;
  @Prop({ default: 'md' }) readonly size!: 'md' | 'lg';
  @Prop({ default: false }) readonly hideLinea!: boolean;

  get iconStyles(): Record<string, string> {
    return {
      backgroundColor: `${this.color}20`,
      color: this.color,
    };
  }
}
